import entities from '@/api/entities'

export default {
    namespaced: true,
    state: {
        items: [],
        selectedItem: null,
        editedId: -1,
        editedItem: {
            name: '',
            street1: '',
            street2: '',
            street3: '',
            postal_code: '',
            city: '',
            country: '',
            contact_emails: '',
            billing_street1: '',
            billing_street2: '',
            billing_street3: '',
            billing_postal_code: '',
            billing_city: '',
            billing_country: '',
            billing_firstname: '',
            billing_lastname: '',
            billing_email: '',
            siret: '',
            vat: '',
            fiscal_number_reference: '',
        },
        defaultItem: {
            name: '',
            street1: '',
            street2: '',
            street3: '',
            postal_code: '',
            city: '',
            country: '',
            contact_emails: '',
            billing_street1: '',
            billing_street2: '',
            billing_street3: '',
            billing_postal_code: '',
            billing_city: '',
            billing_country: '',
            billing_firstname: '',
            billing_lastname: '',
            billing_email: '',
            siret: '',
            vat: '',
            fiscal_number_reference: '',
        }
    },
    getters: {},
    actions: {
        fetchAll ({ commit, rootState }) {
            return new Promise((resolve, reject) => {
                let fetchAllFunction = rootState.auth.user.is_admin_reseller ? entities.indexReseller(rootState.auth.user.reseller.id) : entities.indexUser(rootState.auth.user.id)
                fetchAllFunction.then(response => {
                    commit('setItems', response.data)
                    resolve(response.data)
                }).catch(error => reject(error));
            })
        },
        resetEditedItem ({ commit, state }) {
            commit('setEditedId', -1)
            commit('setEditedItem', Object.assign({}, state.defaultItem))
        },
        saveEditedItem ({ dispatch, state, rootState }) {
            return new Promise((resolve, reject) => {
                entities.store(rootState.auth.user.reseller.id, state.editedItem).then(response => {
                    dispatch('fetchAll')
                    dispatch('resetEditedItem')
                    resolve(response)
                }).catch(error => reject(error))
            })
        },
        updateEditedItem ({ dispatch, state, rootState }) {
            return new Promise((resolve, reject) => {
                entities.update(rootState.auth.user.reseller.id, state.editedId, state.editedItem).then(response => {
                    dispatch('fetchAll')
                    dispatch('resetEditedItem')
                    resolve(response)
                }).catch(error => reject(error))
            })
        },
        deleteItem ({ dispatch, rootState }, id) {
            return new Promise((resolve, reject) => {
                entities.delete(rootState.auth.user.reseller.id, id).then(response => {
                    dispatch('fetchAll')
                    resolve(response)
                }).catch(error => reject(error))
            })
        },
        reset ({ commit, dispatch }) {
            commit('setItems', [])
            dispatch('resetEditedItem')
        },
        saveEmails ({ dispatch, rootState }, { entityId, contactEmails }) {
            return new Promise((resolve, reject) => {
                entities.update(rootState.auth.user.reseller.id, entityId, { contact_emails: contactEmails }).then(() => {
                    dispatch('fetchAll')
                    resolve()
                }).catch(error => reject(error))
            })
        },
        saveLocale ({ dispatch, rootState }, { entityId, contactLang }) {
            return new Promise((resolve, reject) => {
                entities.update(rootState.auth.user.reseller.id, entityId, { contact_lang: contactLang }).then(() => {
                    dispatch('fetchAll')
                    resolve()
                }).catch(error => reject(error))
            })
        },
        saveBillingInformations ({dispatch, rootState}, {entityId, billingLastname, billingFirstname, billingEmail}) {
            return new Promise((resolve, reject) => {
                const data = {
                    billing_lastname: billingLastname,
                    billing_firstname: billingFirstname,
                    billing_email: billingEmail
                }
                entities.update(rootState.auth.user.reseller.id, entityId, data).then(() => {
                    dispatch('fetchAll')
                    resolve()
                }).catch(error => reject(error))
            })
        }
    },
    mutations: {
        setItems (state, items) {
            state.items = items
        },
        setEditedItem (state, item) {
            const editedItem = {
                name: item.name,
                street1: item.street1,
                street2: item.street2,
                street3: item.street3,
                postal_code: item.postal_code,
                city: item.city,
                country: item.country,
                contact_emails: item.contact_emails,
                billing_street1: item.billing_street1,
                billing_street2: item.billing_street2,
                billing_street3: item.billing_street3,
                billing_postal_code: item.billing_postal_code,
                billing_city: item.billing_city,
                billing_country: item.billing_country,
                billing_firstname: item.billing_firstname,
                billing_lastname: item.billing_lastname,
                billing_email: item.billing_email,
                siret: item.siret,
                vat: item.vat,
                fiscal_number_reference: item.fiscal_number_reference
            }
            state.editedItem = editedItem
        },
        setEditedId (state, id) {
            state.editedId = id
        }
    }
}